import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// httpOnly cookie auth — withCredentials sends the access_token cookie on every request.
const api = axios.create({ baseURL: API, withCredentials: true });

export default api;

// ---------- formatErr — surface FastAPI / axios error messages to UI ----------
export function formatErr(e) {
    const d = e?.response?.data?.detail || e?.message || e;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
    if (d && typeof d.msg === "string") return d.msg;
    return "Something went wrong";
}
